import { PRIVILEGES } from 'constants/privileges';
import { InvoicesModule } from 'pages/invoices';
import { InvoiceDetails } from 'pages/invoices/components/InvoiceDetails';
import { InvoiceForm } from 'pages/invoices/components/InvoiceForm';
import { InvoicesClientModule } from 'pages/invoices/InvoicesClientModule';
import { MappingForm } from 'pages/mapping/components/MappingForm';
import { MappingModule } from 'pages/mapping/components/MappingModule';
import { MappingServiceDetails } from 'pages/mapping/components/MappingServiceDetails';
import { RatesModule } from 'pages/rates';
import { RatesDetails } from 'pages/rates/components/RatesDetails';
import { RatesForm } from 'pages/rates/components/RatesForm';
import { TransportCloudModule } from 'pages/transportCloud/components';
import { TransportCloudForm } from 'pages/transportCloud/components/TransportCloudForm';
import { generatePath, Navigate } from 'react-router-dom';
import { DefaultNavItemsNames, NavItems } from 'root/Navbar/navOptions';
import {
  AdminTab,
  EventsTab,
  FilesTab,
  iframePaths,
  InvoiceTab,
  RatesTab,
  PricesTab,
  reactPaths,
  redirectPaths,
  ReportsTab,
  SettingsTab,
  TableTab,
} from 'root/pathnames';
import { RequireAuth } from './AuthRoutes';

export const clientRoutes = [
  { path: reactPaths.invoices, element: <InvoicesClientModule /> },
  { path: reactPaths.rates, element: <RatesModule /> },
  { path: iframePaths.clientRequests, element: null },
  { path: iframePaths.clientOrders, element: null },
  { path: iframePaths.offers, element: null },
  { path: iframePaths.jobs, element: null },
  { path: iframePaths.account, element: null },
  {
    path: redirectPaths.reports,
    element: (
      <Navigate
        replace
        to={generatePath(iframePaths.reportsTab, {
          tab: ReportsTab.ACTIVITIES,
        })}
      />
    ),
  },
  { path: iframePaths.reportsTab, element: null },
];

export const getDefaultRoutes = (
  defaultNavItems: NavItems<DefaultNavItemsNames>,
) => [
  {
    path: reactPaths.invoices,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.invoices.requiredRoles}>
        <Navigate
          replace
          to={generatePath(reactPaths.invoicesModule, {
            tab: InvoiceTab.OWN,
          })}
        />
      </RequireAuth>
    ),
  },
  {
    path: reactPaths.rates,
    element: (
      <Navigate
        replace
        to={generatePath(reactPaths.ratesModule, {
          tab: RatesTab.OWN,
        })}
      />
    ),
  },
  {
    path: reactPaths.ratesForm,
    element: <RatesForm />,
  },
  { path: reactPaths.ratesModule, element: <RatesModule /> },
  {
    path: reactPaths.invoicesModule,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.invoices.requiredRoles}>
        <InvoicesModule />
      </RequireAuth>
    ),
  },
  {
    path: reactPaths.ratesDetails,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.rates.requiredRoles}>
        <RatesDetails />
      </RequireAuth>
    ),
  },
  {
    path: reactPaths.invoicesForm,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.invoices.requiredRoles}>
        <InvoiceForm />
      </RequireAuth>
    ),
  },
  {
    path: reactPaths.invoiceDetails,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.invoices.requiredRoles}>
        <InvoiceDetails />
      </RequireAuth>
    ),
  },
  {
    path: iframePaths.clientRequests,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.inquiries.requiredRoles} />
    ),
  },
  {
    path: reactPaths.transportCloud,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.transportCloud.requiredRoles}>
        <TransportCloudModule />
      </RequireAuth>
    ),
  },
  {
    path: reactPaths.transportCloudForm,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.transportCloud.requiredRoles}>
        <TransportCloudForm />
      </RequireAuth>
    ),
  },
  {
    path: reactPaths.mappingModule,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.mapping.requiredRoles}>
        <MappingModule />
      </RequireAuth>
    ),
  },
  {
    path: reactPaths.mappingForm,
    element: (
      <RequireAuth requiredRoles={[PRIVILEGES.Settings.MANAGE_DISCRIMINANT]}>
        <MappingForm />
      </RequireAuth>
    ),
  },
  {
    path: reactPaths.mappingServiceDetails,
    element: (
      <RequireAuth
        requiredRoles={[PRIVILEGES.Settings.VIEW_DISCRIMINANT_DETAIL]}
      >
        <MappingServiceDetails />
      </RequireAuth>
    ),
  },
  {
    path: iframePaths.clientOrders,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.orders.requiredRoles} />
    ),
  },
  {
    path: iframePaths.offers,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.offers.requiredRoles} />
    ),
  },
  {
    path: iframePaths.jobs,
    element: <RequireAuth requiredRoles={defaultNavItems.jobs.requiredRoles} />,
  },
  {
    path: iframePaths.account,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.account.requiredRoles} />
    ),
  },
  {
    path: redirectPaths.reports,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.reports.requiredRoles}>
        <Navigate
          replace
          to={generatePath(iframePaths.reportsTab, {
            tab: ReportsTab.ACTIVITY,
          })}
        />
      </RequireAuth>
    ),
  },
  {
    path: iframePaths.reportsTab,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.reports.requiredRoles} />
    ),
  },
  {
    path: redirectPaths.files,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.files.requiredRoles}>
        <Navigate
          replace
          to={generatePath(iframePaths.filesTab, {
            tab: FilesTab.COUNTERPARTIES,
          })}
        />
      </RequireAuth>
    ),
  },
  {
    path: iframePaths.filesTab,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.files.requiredRoles} />
    ),
  },
  {
    path: redirectPaths.tables,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.tables.requiredRoles}>
        <Navigate
          replace
          to={generatePath(iframePaths.tableTab, {
            tab: TableTab.CURRENCIES,
          })}
        />
      </RequireAuth>
    ),
  },
  {
    path: iframePaths.tableTab,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.tables.requiredRoles} />
    ),
  },
  {
    path: redirectPaths.prices,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.prices.requiredRoles}>
        <Navigate
          replace
          to={generatePath(iframePaths.pricesTab, {
            tab: PricesTab.TERMINAL_PRICES,
          })}
        />
      </RequireAuth>
    ),
  },
  {
    path: iframePaths.pricesTab,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.prices.requiredRoles} />
    ),
  },
  {
    path: redirectPaths.admin,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.administration.requiredRoles}>
        <Navigate
          replace
          to={generatePath(iframePaths.adminTab, {
            tab: AdminTab.GROUPS,
          })}
        />
      </RequireAuth>
    ),
  },
  {
    path: iframePaths.adminTab,
    element: (
      <RequireAuth
        requiredRoles={defaultNavItems.administration.requiredRoles}
      />
    ),
  },
  {
    path: redirectPaths.settings,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.settings.requiredRoles}>
        <Navigate
          replace
          to={generatePath(iframePaths.settingsTab, {
            tab: SettingsTab.BCT,
          })}
        />
      </RequireAuth>
    ),
  },
  {
    path: iframePaths.settingsTab,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.settings.requiredRoles} />
    ),
  },
  {
    path: redirectPaths.events,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.calendar.requiredRoles}>
        <Navigate
          replace
          to={generatePath(iframePaths.eventsTab, {
            tab: EventsTab.CALENDAR,
          })}
        />
      </RequireAuth>
    ),
  },
  {
    path: iframePaths.eventsTab,
    element: (
      <RequireAuth requiredRoles={defaultNavItems.calendar.requiredRoles} />
    ),
  },
];
